<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('departments.create')" @invoke-method="invokeMethod($event)" action="openDepartmentForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetDepartments(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <bc-circle-loader v-if="loading"></bc-circle-loader>
                <v-card-text v-else :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="departments" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openDepartmentForm(props.item)">
                                <td>{{ props.item.department_id }}</td>
                                <td>{{ props.item.department_name }}</td>
                                <td>{{ props.item.manager_name }}</td>
                                <td>{{ props.item.location_id }}</td>
                                <td>{{ props.item.cost_center }}</td>
                                <td>{{ props.item.budget }}</td>
                                <td>{{ props.item.start_date }}</td>
                                <td>{{ props.item.end_date }}</td>
                                <td>{{ props.item.parent_department_id }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="departments"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="department_dialog">
                <v-card>
                    <v-form ref="form_department">
                        <v-card-title>
                            <span class="headline">{{ department.department_id ? $t("lang.edit_department") : $t("lang.add_department") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeDepartmentDialog"
                                :dialog-status="department_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs6>
                                        <v-flex xs12>
                                            <v-text-field
                                                v-focus="department_dialog"
                                                v-model="department.department_id"
                                                :label="$t('lang.department_id')"
                                                :counter="showCounter(department.department_id, 'departments.department_id')"
                                                :rules="ifValid('departments.department_id')"
                                                readonly
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                v-model="department.department_name"
                                                :label="`${$t('lang.department_name')} *`"
                                                :counter="showCounter(department.department_name, 'departments.department_name')"
                                                :rules="ifValid('departments.department_name')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <bc-autocomplete
                                                v-model="department.manager_id"
                                                :label="$t('lang.manager_id')"
                                                :items="people"
                                                item-value="people_id"
                                                item-text="combined_name"
                                                :rules="ifValid('departments.manager_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                v-model="department.location_id"
                                                :label="$t('lang.location_id')"
                                                :counter="showCounter(department.location_id, 'departments.location_id')"
                                                :rules="ifValid('departments.location_id')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-textarea
                                                v-model="department.description"
                                                :label="$t('lang.description')"
                                                auto-grow
                                                rows="1"
                                                :rules="ifValid('departments.description')"
                                            ></v-textarea>
                                        </v-flex>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-flex xs12>
                                            <v-text-field
                                                v-model="department.cost_center"
                                                :label="$t('lang.cost_center')"
                                                :counter="showCounter(department.cost_center, 'departments.cost_center')"
                                                :rules="ifValid('departments.cost_center')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <v-text-field
                                                v-model="department.budget"
                                                :label="$t('lang.budget')"
                                                :counter="showCounter(department.budget, 'departments.budget')"
                                                :rules="ifValid('departments.budget')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12>
                                            <bc-date-picker
                                                v-model="department.start_date"
                                                :label="$t('lang.start_date')"
                                                :rules="ifValid('departments.start_date')"
                                            ></bc-date-picker>
                                        </v-flex>
                                        <v-flex xs12>
                                            <bc-date-picker
                                                v-model="department.end_date"
                                                :label="$t('lang.end_date')"
                                                :rules="ifValid('departments.end_date')"
                                            ></bc-date-picker>
                                        </v-flex>
                                        <v-flex xs12>
                                            <bc-autocomplete
                                                v-model="department.parent_department_id"
                                                :label="$t('lang.parent_department_id')"
                                                :items="departments"
                                                item-value="department_id"
                                                item-text="department_name"
                                                :rules="ifValid('departments.parent_department_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="department.department_id" color="error" @mouseup.left="$refs.delete_departments.openDialog()">{{
                                $t("lang.delete")
                            }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeDepartmentDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveDepartments">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_departments"
                :heading="$t('lang.delete_department')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteDepartments(department.department_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import _ from "lodash";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openDepartmentForm" },
                { title: this.$t("lang.refresh"), action: "dbGetDepartments", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.department_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.department_name"), sortable: false, width: "10%" },
                { text: this.$t("lang.manager_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.location_id"), sortable: false, width: "10%" },
                { text: this.$t("lang.cost_center"), sortable: false, width: "10%" },
                { text: this.$t("lang.budget"), sortable: false, width: "10%" },
                { text: this.$t("lang.start_date"), sortable: false, width: "10%" },
                { text: this.$t("lang.end_date"), sortable: false, width: "10%" },
                { text: this.$t("lang.parent_department_id"), sortable: false, width: "10%" },
            ],
            enableAddModal: true,
            enableEditModal: true,

            department: {},
            filter: {
                search: "",
            },
            department_dialog: false,
            dbGetDepartments: _.debounce(this.getDepartments, 1500, { maxWait: 1500, leading: true, trailing: false }),
            people: null,
            loading: true,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.loading = true;
            _.delay(() => {
                let parsedQuery = JSON.parse(JSON.stringify(to.query));
                store
                    .dispatch("fetchDepartments", {
                        body: parsedQuery,
                    })
                    .then((data) => {
                        if (typeof data !== "undefined" && data.departments) {
                            vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                            vm.finishLoader();
                            vm.loading = false;
                        } else {
                            next({ name: "dashboard", replace: true });
                        }
                    });
            }, 500);
        });
    },
    beforeRouteUpdate(to, from, next) {
        this.loading = true;
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        _.delay(() => {
            this.fetchDepartments({
                body: parsedQuery,
            }).then((data) => {
                if (typeof data !== "undefined" && data.departments) {
                    this.setQuery(parsedQuery, this.filter, this.default_filter);
                    this.finishLoader();
                    this.loading = false;
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
        }, 500);
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.departments.departments_filter,
            page: (state) => state.departments.page,
            rules_departments: (state) => state.departments.rules_departments,
            department_status_options: (state) => state.settings.department_status_options,
            departments: (state) => state.departments.departments,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchDepartments", "saveDepartment", "deleteDepartment"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openDepartmentForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_department) item ? this.$refs.form_department.resetValidation() : this.$refs.form_department.reset();

                    this.$nextTick(() => {
                        this.department = item != null ? this.assignObj2(item, this.rules_departments) : {};
                        this.department_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "department", params: { id: item.department_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.customers == null) this.getCustomers();
                    if (this.$refs.form_department) item ? this.$refs.form_department.resetValidation() : this.$refs.form_department.reset();
                    this.department_dialog = true;
                } else {
                    this.$router.push({ name: "department" });
                }
            }
        },
        saveDepartments() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_department")) {
                    let body = this.prepForm(this.department, this.rules_departments);

                    this.saveDepartment({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getDepartments();
                                this.closeDepartmentDialog();
                            } else {
                                this.$router.push({ name: "department", params: { id: data.department_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteDepartments(id = null) {
            this.deleteDepartment({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getDepartments();
                    this.closeDepartmentDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeDepartmentDialog() {
            this.department_dialog = false;
            this.$refs.delete_departments.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getDepartments(pg_refresh = false) {
            this.startLoader();
            this.loading = true;
            _.delay(() => {
                this.fetchDepartments({
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                    .then((data) => {
                        if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    })
                    .finally(() => {
                        this.department_dialog = false;
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(pg_refresh);
                        this.loading = false;
                    });
            }, 500);
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        getPeople() {
            this.startLoader();

            this.$store
                .dispatch("fetchPeople", {
                    url: "people",
                    method: "get",
                    commit: true,
                    body: {
                        slug: "employee",
                    },
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                    this.people = data.people;
                    console.log(this.people);
                })
                .finally(() => {
                    this.finishLoader(false);
                });

            this.finishLoader();
        },
    },
    created() {
        if (this.people == null) this.getPeople();
    },
};
</script>
